import React from 'react';
import { getEnv } from '@config';

import PropTypes from 'prop-types';
import styled from 'styled-components';
const { notificationBulletColor } = getEnv();

import { Icon } from '..';

const Item = styled.div`
  width: 100%;
  cursor: pointer;
  display: flex;
  padding: 20px 16px 20px 24px;
  min-width: 216px;
  position: sticky;
  & > svg {
    color: #c0dbf3;
  }
  :hover {
    background: #0268bc;
  }
`;

const LinkTitle = styled.div`
  width: 100%;
  font-size: 12px;
  padding: 3px 0px;
  padding-left: ${({ padding }) => (padding ? `${padding}px` : '15px')};
  color: #c0dbf3;
`;

const Bullet = styled.div`
  width: 8px;
  height: 8px;
  border-radius: 5px;
  background: ${notificationBulletColor};
  position: absolute;
  left: 15px;
  top: 47%;
`;

function NavMenuItem({
  icon = null,
  navExpanded = false,
  title = null,
  padding = 0,
  showBullet = false,
  ...rest
}) {
  return (
    <Item {...rest}>
      {showBullet && <Bullet className="bullet" />}
      {icon && <Icon className="icon" size="24" icon={icon} />}
      <LinkTitle padding={padding ? 40 : null} isOpen={navExpanded}>
        {title}
      </LinkTitle>
    </Item>
  );
}

NavMenuItem.propTypes = {
  title: PropTypes.any.isRequired,
};

export default NavMenuItem;
